import { styled as o } from "@lokalise/styled";
const r = o.button`
	cursor: pointer;
`;
export {
  r as Root
};
//# sourceMappingURL=styles.js.map
